import type { TroubleshootingParams } from '../../../utils/hooks/useTroubleshootingFetch';

/**
 * Get date part for CSV filename based on troubleshooting params
 */
const getCsvFilenameDatePart = (params?: TroubleshootingParams): string => {
  if (!params) {
    return '';
  }

  // For 24h (NRT jobs) - use 'last-24h'
  if (params.lookbackHours) {
    return 'last-24h';
  }

  // For date ranges (Fact jobs) - use startDate-endDate
  if (params.startDate && params.endDate) {
    return `${params.startDate}-${params.endDate}`;
  }

  // Fallback: if only one date is available
  if (params.startDate) {
    return params.startDate;
  }

  if (params.endDate) {
    return params.endDate;
  }

  return '';
};

/**
 * Generate CSV filename for troubleshooting exports
 */
export const getTroubleshootingCsvFilename = (
  dealId: string,
  type: 'funnel' | 'metrics',
  params?: TroubleshootingParams
): string => {
  const datesPart = getCsvFilenameDatePart(params);
  const typePart = type === 'funnel' ? 'funnel' : 'metrics';
  return `deal${dealId}_troubleshooting_${typePart}${datesPart ? `_${datesPart}` : ''}.csv`;
};
